import {
  setAbstractFetchFunc,
  setAbstractConvertRequestFunc,
  setAbstractConvertResponseFunc,
  setAbstractConvertHeadersFunc,
  setAbstractRuntimeString,
} from '../../runtime';
import {
  webApiConvertHeaders,
  webApiConvertRequest,
  webApiConvertResponse,
} from '../web-api/adapter';

import {workerRuntimeString} from './adapter';

setAbstractFetchFunc(fetch);
setAbstractConvertRequestFunc(webApiConvertRequest);
setAbstractConvertResponseFunc(webApiConvertResponse);
setAbstractConvertHeadersFunc(webApiConvertHeaders);
setAbstractRuntimeString(workerRuntimeString);

// Export a marker to prevent tree-shaking
export const cfWorkerAdapterInitialized = true;
